import * as React from "react";

import { UitkExpandoCard } from "uitk-react-expando";
import { UitkLayoutGrid, UitkLayoutGridColumnRow } from "uitk-react-layout-grid";
import { UitkSpacing } from "uitk-react-spacing";

import Link from "./components/Link";
import { ItemKeyHelper } from "components/utility/ItemKeyHelper";
import { LinkJuiceCategorySectionProps } from "./typings";

const LinkJuiceCategorySection = (props: LinkJuiceCategorySectionProps) => {
  const { category, collapsed, displayColumns } = props;
  const { name, links } = category;
  if (!(name && links && links.length)) {
    return null;
  }

  const DEFAULT_MOBILE_DISPLAY_COLUMNS = 1;
  const columns = {
    small: DEFAULT_MOBILE_DISPLAY_COLUMNS as UitkLayoutGridColumnRow,
    large: Number(displayColumns) as UitkLayoutGridColumnRow,
  };

  const [isExpanded, setIsExpanded] = React.useState(!collapsed);

  const toggleExpansion = (): void => {
    setIsExpanded(!isExpanded);
  };

  const keyHelper = new ItemKeyHelper("LinkJuiceLinks");

  return (
    <UitkSpacing margin="one">
      <UitkExpandoCard
        expandoTitle={name}
        isVisible={isExpanded}
        handleClick={toggleExpansion}
        expandoDescription={
          <UitkLayoutGrid columns={columns} space="one">
            {links.map((link) => (
              <Link key={keyHelper.next()} link={link} />
            ))}
          </UitkLayoutGrid>
        }
      />
    </UitkSpacing>
  );
};

export default LinkJuiceCategorySection;
